// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3uahw","rootSmall":"AddTileButton_rootSmall__2fjBc"};